import { fromAsync } from "../../async/static/fromAsync.js";
export const zipAsync = (first, second, resultSelector) => {
    async function* generator() {
        const firstIterator = first[Symbol.iterator]();
        const secondIterator = second[Symbol.iterator]();
        while (true) {
            const a = firstIterator.next();
            const b = secondIterator.next();
            if (a.done || b.done) {
                break;
            }
            else {
                yield resultSelector(a.value, b.value);
            }
        }
    }
    return fromAsync(generator);
};
